<ng-container *ngIf="clientsWithPills$ | async as clientsWithPills">
	<ui-content-header
		type="page"
		[title]="(title$ | async) + 's'"
		[testHook]="testHooks.ContentHeader"
	>
		<ui-button
			title-action
			icon="plus"
			(click)="addClient()"
			[label]="addButtonText$ | async"
			[testHook]="testHooks.Button"
		></ui-button>
	</ui-content-header>
	<div [grid] class="@container">
		<div
			class="inline-flex gap-4 flex-col @3xl:col-span-6 @6xl:col-span-5 col-span-12"
		>
			<ng-container *ngIf="clientsWithPills.length > 0; else noClients">
				<app-container
					type="card"
					*ngFor="let clientWithPill of clientsWithPills; trackBy: trackClient"
					class="flex-none"
				>
					<atomic-party-client-card
						[client]="clientWithPill.client"
						[pills]="clientWithPill.pills"
						[isOtherParties]="true"
						[kebabOptions]="clientKebabOptions"
						(onKebabSelect)="
							onClientKebabSelect(clientWithPill.client.id, $event)
						"
						[testHook]="testHooks.PartyClientCard"
					></atomic-party-client-card>
				</app-container>
			</ng-container>

			<ng-template #noClients>
				<div
					class="flex flex-col gap-y-4 bg-white rounded-xl border border-gray-200 px-8 pt-20"
				>
					<div class="text-center flex flex-col gap-y-1 pb-20">
						<h5 class="h5">No vendors added yet.</h5>
					</div>
				</div>
			</ng-template>

			<ui-section
				title="Capacity"
				*ngIf="showCapacity$ | async"
				[testHook]="testHooks.CapacitySection"
			>
				<app-party-capacity section-content></app-party-capacity>
			</ui-section>
		</div>

		<div
			class="inline-flex gap-4 flex-col @3xl:col-span-6 @6xl:col-span-7 col-span-12"
		>
			<ui-section
				[title]="(title$ | async) + ' Law Firm'"
				class="[&>div]:overflow-visible"
				[testHook]="testHooks.Section"
			>
				<app-law-firms
					section-content
					class="w-full"
					[showClerk]="showClerk"
					[fileNumber]="fileNumber$ | async"
					[showFileNumber]="true"
					placeholder="Search Lawyer, Clerk or Law Firm"
					[lawFirm]="lawFirm$ | async"
					(onUpdate)="_onLawFirmUpdate($event)"
					(onUpdateFileNumber)="onFileNumberUpdated($event)"
				></app-law-firms>
			</ui-section>

			<ui-section
				[title]="(title$ | async) + ' Brokerage'"
				class="[&>div]:overflow-visible"
				[testHook]="testHooks.Section1"
			>
				<app-brokerage
					section-content
					[isClientBrokerage]="otherParty"
				></app-brokerage>
			</ui-section>
		</div>
	</div>
</ng-container>
